import React from "react";

const NotFound = () => (
  <div className="not-found">
    <h2>Page Not Found</h2>
  </div>
);

export default NotFound;